// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"225":"d4af1399","493":"cabf18bd","640":"59681f37","752":"584b634c","755":"4882c8f2","841":"8457f448","861":"e90ed8c5","880":"e23e8a9f","980":"b799b2a7"}[chunkId] + ".css";
};